import { post } from '@/utils/network';
import services from '@/services/learningStatistics';

// 获取互动课件详情
const getInteract = ({ interactid }: { interactid: string }) => {
  return post<{
    interact: {
      id: string;
      title: string;
      createtime: string;
      over: string;
      type: string;
      filename: string;
      uid: string;
      userInfo: {
        id: string;
        username: string;
      };
    };
    publishInfo: {
      id: string;
      title: string;
      content: string;
      courseid: string;
      fromid: string;
      type: string;
      state: string;
      uid: string;
      publishcount: string;
      endtime: string;
      pages: string;
      allowanswer: string;
      createtime: string;
      updatetime: string;
      status: string;
      deltime: string;
      allowdown: string;
      interactState: number;
    };
  }>('/InteractApi/getInteract', { interactid });
};

// 互动课件-图片列表
const listSlides = ({ interactid }: { interactid: string }) => {
  return post<any>('/InteractPPTApi/listSlides', { interactid });
};

// 获取 某个 课件的使用统计 [课堂内容]
const getCoursewareUseStatV2 = ({ id, page, limit, type, sort }: { id: string; page: number; limit: number; type: number; sort: number }) => {
  return post<{
    list: {
      currentPage: number;
      pageSize: number;
      pageTotal: number;
      total: number;
      list: Array<{
        username: string;
        stno: string;
        id: string;
        watchnum: number;
        updatetime: string;
        downcount: string;
        commentCount: string;
        learnLength: number;
        lastVisitTime: string | null;
      }>;
    };
    statistics: {
      carryoutcount: string;
      learncount: string;
      notcount: number;
    };
  }>('/CoursewareApi/getCoursewareUseStatV2', { id, page, limit, type, sort });
};

// 获取学生的预习情况的统计表
// filter 1表示未学习，2表示已学习但未提交，3表示已完成学习
const getStatinfoV2 = ({ interactid, txt, filter, pageSize , currentPage}: { interactid: string; txt: string; filter: number,pageSize:any,currentPage:any }) => {
  return post<{
    total:number;
    pageCount: number;
    lists: Array<{
      username: string;
      stno: string;
      id: string;
      nikename: null | string;
      nikestno: null | string;
      visitPageCount: number;
      doubtCount: string;
      commentCount: string;
      totalPage: number;
      avatar: string;
      timeline: string;
      finish: number;
      endtime: null | string;
      downCount: number;
      learning: number;
    }>;
    task: {
      createtime: string;
      finishCount: string;
      studyCount: string;
      noStudyCount: number;
      studentCount: string;
    };
  }>('/PrestudyTaskManageApi/getStatinfoV2', { interactid, txt, filter,pageSize,currentPage });
};

// 获取互动课件的每个页面的预习情况
// status 0 全部 | 1 疑问 | 2评论
const getListSlides = ({ interactid, status, clienttype = 1 }: { interactid: string; status: number; clienttype?: number }) => {
  return post<{
    commentCountTotal: number;
    currentPage: number;
    lists: Array<{
      commentCount: string;
      pageindex: string;
      qCount: string;
      src: string;
      thumb_src: string;
    }>;
    pageSize: number;
    pageTotal: number;
    qCountTotal: number;
    total: number;
  }>('/PrestudyTaskManageApi/listSlides', { interactid, status, clienttype });
};

// 获取某个互动的所有环节
const getStepList = ({ interactid }: { interactid: string }) => {
  return post<{
    list: Array<{
      createtime: string;
      enable: string;
      handupCount: string;
      id: string;
      objectAccuracy: number;
      over: string;
      pageIndex: string;
      reviewedNum: string;
      studentCount: string;
      subjectCount: string;
      title: string;
      reviewStatus: number; // 批阅状态按钮 控制 1 开始批阅 | 2继续批阅 |3 批阅完成
      slide: {
        enable: string;
        over: string;
        pageindex: string;
        src: string;
        stepid: string;
        thumb_src: string;
      };
    }>;
  }>('/InteractApi/getStepList', { interactid });
};

// 获取学生的疑问的列表
const getDoubtStudentListsV2 = ({ interactid, pageindex }: { interactid: string; pageindex: string }) => {
  return post<{
    data: Array<{
      createtime: string;
      stno: string;
      username: string;
      avatar: string;
    }>;
  }>('/PrestudyTaskManageApi/getDoubtStudentListsV2', { interactid, pageindex });
};

// 课件评论-列表[老师+学生]
const getCommentStudentLists = ({ interactid, pageindex }: { interactid: string; pageindex: string }) => {
  return post<
    Array<{
      id: string;
      uid: string;
      comment: string;
      createtime: string;
      anonymous: string;
      replyid: null | string;
      isTeacher: number; //当前用户是否是老师【0是1否】
      stno: string;
      username: string;
      avatar: string;
      del: number;
      children: Array<any>; //当前用户是否可以删除【0否1是】
      childen: Array<{
        id: string;
        uid: string;
        comment: string;
        createtime: string;
        anonymous: string;
        replyid: string;
        isTeacher: number;
        stno: string;
        username: string;
        avatar: string;
      }>;
    }>
  >('PrestudyTaskManageApi/getCommentStudentLists', { interactid, pageindex });
};

// ------ 开始上课-学生

// 互动课件 预习内容-列表【学生端】
const preStudyList = ({ interactid }: { interactid: string }) => {
  return post<{
    pageCount: number;
    pptUrl: string;
    data: {
      [index: number]: {
        commentCount: string;
        pageCount: number;
        pageindex: string;
        pptType: number;
        selfdoubt: number;
        src: string;
        stepid: string;
        subjectCount: string;
        thumb_src: string;
      };
    };
  }>('/PrestudyTaskApi/preStudyList', { interactid });
};

// 互动课件的统计学习时长
const addLearnTime = (interactid: string) => {
  return post('/PrestudyTaskApi/addLearnTime', {
    interactid
  })
}
//互动课件 学生疑问-状态切换
const setDoubtState = ({ interactid, pageindex, state }: { interactid: string; pageindex: string; state: number }) => {
  return post<any>('/PrestudyTaskApi/setDoubtState', { interactid, pageindex, state });
};

// 获取已经学习过得的页码
const getPreStudyInfo = ({ interactid }: { interactid: string }) => {
  return post<{
    allowdown: string; // 下载： 1 - 允许、0 - 不允许
    studyPageIndex: Array<string>;
    studyStatus: boolean; //是否是最后一页【true是false否】
    prestudyStatus: string; //学习状态，0未学习，1学习中，2已完成
  }>('/PrestudyTaskApi/getPreStudyInfo', { interactid });
};

// 课件评论-新增
const addComment = ({ interactid, pageindex, comment, replyid }: { interactid: string; pageindex: string; comment: string; replyid: string }) => {
  return post<any>('/PrestudyTaskApi/addComment', { interactid, pageindex, comment, replyid });
};

// 删除评论-讨论
const delComment = ({ id }: { id: string }) => {
  return post<any>('/PrestudyTaskApi/delComment', { id });
};

// 课件学习接口
const studyTaskPageIndex = ({ interactid, pageindex }: { interactid: string; pageindex: string }) => {
  return post<any>('/PrestudyTaskApi/studyTaskPageIndex', { interactid, pageindex });
};

// 结束预习
const finishStudyTask = ({ interactid }: { interactid: string }) => {
  return post<any>('/PrestudyTaskApi/finishStudyTask', { interactid });
};

// 课程列表目录
export function getCourseDirectory() {
  return post('/CourseApi/getCourseDirectory')
}

// 下载课件
export const downloadPPT = (data: { interactid: string }) => {
  return post<{ downurl: string; info: string; status: number }>('/InteractPPTApi/downloadppt', data)
}

// 保存课程模板类型
export function saveTempleteType(params: { courseid: string, type: string }) {
  return post('/Futurev2/CourseTemplate/saveTempleteType', params)
}

// 获取课程模板的设置
export function getSetting(params: { courseid: string }) {
  return post('/Futurev2/CourseTemplate/getSetting', params)
}

// 更新栏目设置
export function updateSetting(params: { courseid: string, navigation: object[] }) {
  return post('/Futurev2/CourseTemplate/updateSetting', params)
}
// 手动结束学习
export function closePreStudy(params: { interactid: string }) {
  return post('/PrestudyTaskApi/closePreStudy', params)
}

export function getListsByFileType(params: { courseid: string; fileType:string, page: number; limit: number }){
  return post('/CoursewareApi/getListsByFileType',params)
}

export default {
  getInteract,
  listSlides,
  getCoursewareUseStatV2,
  getStatinfoV2,
  getListSlides,
  getStepList,
  getDoubtStudentListsV2,
  getCommentStudentLists,
  preStudyList,
  setDoubtState,
  getPreStudyInfo,
  addComment,
  delComment,
  studyTaskPageIndex,
  finishStudyTask,
  addLearnTime,
  closePreStudy,
  getListsByFileType
};
